var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.628601 0.628571V17.5429C0.628601 20.3177 2.88232 22.5714 5.65717 22.5714H17.5429C20.3177 22.5714 22.5715 20.3177 22.5715 17.5429V0.628571H0.628601ZM21.6572 17.5429C21.6572 19.8103 19.8103 21.6571 17.5429 21.6571H5.65717C3.38974 21.6571 1.54289 19.8103 1.54289 17.5429V1.54286H21.6572V17.5429Z",
    fill: "#00A069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.28572H5.20001V5.20001H18V4.28572Z",
    fill: "#00A069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1703 16.1806L7.35318 12.3634L6.70404 13.008L11.3623 17.6663L16.5692 8.66057L15.7738 8.20343L11.1703 16.1806Z",
    fill: "#00A069"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9429,
    height: 21.9429,
    fill: "white",
    transform: "translate(0.628601 0.628571)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventGreen);
export default __webpack_public_path__ + "static/media/event-green.36f2070f1bc58f5612e5985fa258728c.svg";
export { ForwardRef as ReactComponent };